import { connect } from "react-redux";
import DiscountTypesCode from "../js/admin/DiscountTypesCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../components/EntityPage";




class DiscountTypes extends EntityPage {
    constructor(props) {
        super('admin_local.menus.discounts');
        this.code = new DiscountTypesCode()
        this.code.setRoles(props.roles || []);
    }

    componentDidUpdate = () => {
        this.code.setRoles(this.props.roles || []);
        super.componentDidUpdate();
    }

}
const mapStateToProps = (props) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            roles: Object.keys(props.rootReducer?.rbac?._roles) || []
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(DiscountTypes));
